var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0C6.383 0 4.25391 2.1291 4.25391 4.74609C4.25391 7.36309 6.383 9.49219 9 9.49219C11.617 9.49219 13.7461 7.36309 13.7461 4.74609C13.7461 2.1291 11.617 0 9 0ZM9 8.4375C6.96456 8.4375 5.30859 6.78154 5.30859 4.74609C5.30859 2.71065 6.96456 1.05469 9 1.05469C11.0354 1.05469 12.6914 2.71065 12.6914 4.74609C12.6914 6.78154 11.0354 8.4375 9 8.4375Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9051 12.5928C13.6057 11.2734 11.8831 10.5469 10.0547 10.5469H7.94531C6.11691 10.5469 4.39432 11.2734 3.09495 12.5928C1.80193 13.9057 1.08984 15.6387 1.08984 17.4727C1.08984 17.7639 1.32595 18 1.61719 18H16.3828C16.674 18 16.9102 17.7639 16.9102 17.4727C16.9102 15.6387 16.1981 13.9057 14.9051 12.5928ZM2.16773 16.9453C2.43193 13.954 4.92226 11.6016 7.94531 11.6016H10.0547C13.0777 11.6016 15.5681 13.954 15.8323 16.9453H2.16773Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.1973e87b0d797e58a77179ffc6b45eab.svg";
export { ForwardRef as ReactComponent };